export var ANONYMOUS_USER = '14733ANONYMOUS';
export var ANONYMOUS_PASSWORD = 'kry8x2pa';
export var PAYMENT_TERMS_LINK = '/#/hjelp/terms';
export var ACTIONS = {
    CHANGED_ACTION: 'CHANGED_ACTION',
    GO_NEXT_ACTION: 'GO_NEXT_ACTION',
    GO_BACK_ACTION: 'GO_BACK_ACTION',
    CANCEL_ACTION: 'CANCEL_ACTION',
    FINISHED_ACTION: 'FINISHED_ACTION',
    TAG_UPDATED_ACTION: 'TAG_UPDATED_ACTION',
    EMAIL_UPDATED_ACTION: 'EMAIL_UPDATED_ACTION',
    PAGE_VALID_ACTION: 'PAGE_VALID_ACTION',
    CARD_USER_CREATED_SUCCESSFULLY_ACTION: 'CARD_USER_CREATED_SUCCESSFULLY_ACTION',
    CARD_USER_CREATION_CRASHED_ACTION: 'CARD_USER_CREATION_CRASHED_ACTION',
    NE_USER_DETERMINED_ACTION: 'NE_USER_DETERMINED_ACTION',
    NE_USER_UNKNOWN_ACTION: 'NE_USER_UNKNOWN_ACTION',
    GET_POSTAL_ADDRESS_ACTION: 'GET_POSTAL_ADDRESS_ACTION',
    CHECK_ORGANIZATION_NUMBER_ACTION: 'CHECK_ORGANIZATION_NUMBER_ACTION',
    FAILED_POSTAL_ADDRESS_ACTION: 'FAILED_POSTAL_ADDRESS_ACTION',
    FAILED_ORGANIZATION_NUMBER_ACTION: 'FAILED_ORGANIZATION_NUMBER_ACTION',
    NEW_SUBSCRIPTION_CUSTOMER_INFO_POST_SUCCESS_ACTION: 'NEW_SUBSCRIPTION_CUSTOMER_INFO_POST_SUCCESS_ACTION',
    NEW_SUBSCRIPTION_CUSTOMER_INFO_POST_ERROR_ACTION: 'NEW_SUBSCRIPTION_CUSTOMER_INFO_POST_ERROR_ACTION'
};
export var EVENTS = {
    CHANGED_EVENT: 'CHANGED_EVENT',
    GO_NEXT_EVENT: 'GO_NEXT_EVENT',
    GO_BACK_EVENT: 'GO_BACK_EVENT',
    CANCEL_EVENT: 'CANCEL_EVENT',
    FINISHED_EVENT: 'FINISHED_EVENT',
    TAG_UPDATED_EVENT: 'TAG_UPDATED_EVENT',
    EMAIL_UPDATED_EVENT: 'EMAIL_UPDATED_EVENT',
    PAGE_VALID_EVENT: 'PAGE_VALID_EVENT',
    CARD_USER_CREATED_SUCCESSFULLY_EVENT: 'CARD_USER_CREATED_SUCCESSFULLY_EVENT',
    CARD_USER_CREATION_CRASHED_EVENT: 'CARD_USER_CREATION_CRASHED_EVENT',
    NE_USER_DETERMINED_EVENT: 'NE_USER_DETERMINED_EVENT',
    NE_USER_UNKNOWN_EVENT: 'NE_USER_UNKNOWN_EVENT',
    GET_POSTAL_ADDRESS_EVENT: 'GET_POSTAL_ADDRESS_EVENT',
    CHECK_ORGANIZATION_NUMBER_EVENT: 'CHECK_ORGANIZATION_NUMBER_EVENT',
    FAILED_POSTAL_ADDRESS_EVENT: 'FAILED_POSTAL_ADDRESS_EVENT',
    FAILED_ORGANIZATION_NUMBER_EVENT: 'FAILED_ORGANIZATION_NUMBER_EVENT',
    NEW_SUBSCRIPTION_CUSTOMER_INFO_POST_SUCCESS_EVENT: 'NEW_SUBSCRIPTION_CUSTOMER_INFO_POST_SUCCESS_EVENT',
    NEW_SUBSCRIPTION_CUSTOMER_INFO_POST_ERROR_EVENT: 'NEW_SUBSCRIPTION_CUSTOMER_INFO_POST_ERROR_EVENT'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ambita/ambita-components-infoland-internal/dist/components/constants/User.js
// module id = 1
// module chunks = 2